import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { Input } from 'components/fields'
import { Row, Col, Form } from 'components/layout'
import { FormButton, Module, MobileApps } from 'components/misc'
import { ChooseRole, ChangePassword } from 'containers/misc'
import { form } from 'helpers/decorators'
import { apiLogin } from 'helpers/decorators/api'
import { validate } from 'models/login'
import config from 'config'

const enhance = compose(
  form({
    form: 'loginForm',
    disableHook: true,
    validate
  }),
  apiLogin()
)

class FormLogin extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    untouch: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  }

  static defaultProps = {
    loading: false
  }

  render() {
    const { handleSubmit, onLogin, submitting } = this.props

    return (
      <Module withFooter>
        <Form
          onSubmit={handleSubmit(fields => onLogin(fields))}
          autoComplete="off"
        >
          <Row column spaceBetween>
            <Col>
              <h2 className="alpha-color base-margin--bottom">
                <FormattedMessage
                  id="moduleTitle.login"
                  defaultMessage="Login"
                />
              </h2>

              <Input
                autoComplete="username"
                name="username"
                label="Email"
                intlKey="label.email"
                dataTestId="loginInputName"
              />
              <Input
                autoComplete="current-password"
                name="password"
                label="Password"
                intlKey="label.password"
                type="password"
                dataTestId="loginInputPassword"
              />
            </Col>
            <Col>
              <div className="base-margin--bottom">
                <Link className="link" to={`${config.publicPath}/auth/forgotten-password`}>
                  <FormattedMessage
                    id="button.forgot_your_password"
                    defaultMessage="Forgot your password?"
                  />
                </Link>
              </div>
            </Col>

            <FormButton
              {...this.props}
              isLoading={submitting}
              dataTestId="loginSubmitButton"
              simple
              fluid
            >
              <FormattedMessage id="button.login" defaultMessage="Log In" />
            </FormButton>

            <MobileApps />
          </Row>
        </Form>

        <ChooseRole />
        <ChangePassword />
      </Module>
    )
  }
}

export default enhance(FormLogin)
